export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_fragment_5.bf85db0b.jpg";